import { useEffect, useState } from "react";
import { Button, notification } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { refreshFleet, subscribeToFleetUpdate } from "../versionGuard";

export default function FleetUpdateNotice() {
  const [update, setUpdate] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const { t, i18n } = useTranslation();
  useEffect(() => subscribeToFleetUpdate(setUpdate), []);
  useEffect(() => {
    if (!update) { api.destroy('fleet-update'); return; }
    const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
    const candidate = update.highlights?.[language] || update.highlights?.en;
    const highlights = Array.isArray(candidate) ? candidate.filter(value => typeof value === 'string').slice(0, 4) : [];
    api.open({
      key: 'fleet-update',
      placement: 'bottomRight',
      duration: 0,
      message: t('fleetUpdate.title'),
      description: <>
        {highlights.length > 0 && <ul style={{ paddingLeft: 18, margin: '0 0 12px' }}>{highlights.map((text, index) => <li key={index}>{text}</li>)}</ul>}
        <p style={{ margin: '0 0 12px' }}>{t('fleetUpdate.saveFirst')}</p>
        <Button type="primary" icon={<ReloadOutlined />} onClick={() => refreshFleet(update)}>{t('fleetUpdate.refresh')}</Button>
      </>,
    });
    return () => api.destroy('fleet-update');
  }, [api, update, t, i18n.resolvedLanguage, i18n.language]);
  return contextHolder;
}
